import { FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export const crossValidator:
  ValidatorFn = (control: FormGroup):
    ValidationErrors | null => {
 

    return  null;

};
